import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Typography, TextField } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '100%',
    maxWidth: '650px',
    margin: '0 auto 30px auto',
  },
  heading: {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: '17px',
    marginBottom: '5px',
    '@media (max-width: 600px)': {
      fontSize: '16px',
    },
  },
  subHeading: {
    color: theme.palette.text.primary,
    fontWeight: 300,
    fontSize: '15px',
    marginBottom: '0',
  },
  textInput: {
    padding: '5px 10px',
  },
}));

const TextAreaFormElement = props => {
  const [textValue, setTextValue] = useState('');
  const classes = useStyles();

  useEffect(() => {
    setTextValue('');
  }, [props.id]);

  const handleChange = event => {
    setTextValue(event.target.value);
    props.handleSurveyAnswers(event.target.value, props.id);
  };

  return (
    <Box className={classes.mainContainer}>
      {props.heading && (
        <Typography component="div" variant="h3" className={classes.heading}>
          {props.heading}
        </Typography>
      )}
      {props.subHeading && (
        <Typography component="div" variant="h4" className={classes.subHeading}>
          {props.subHeading}
        </Typography>
      )}
      <Box maxWidth="650px" margin="20px auto 0 auto">
        <TextField
          fullWidth
          onChange={handleChange}
          variant="outlined"
          multiline
          minRows={4}
          value={props.value ? props.value : textValue}
          inputProps={{
            className: classes.textInput,
          }}
        />
      </Box>
    </Box>
  );
};

export default TextAreaFormElement;
